export default [
  {
    path: '/configuracoes-apis',
    name: 'configuracaoapi',
    component: () => import('@/app-modulo/comuns/configuracao-api/ConfiguracaoApi.vue'),
    meta: {
      resource: 'configuracaoapi',
      action: 'create',
      pageTitle: 'API',
      breadcrumb: [],
    },
  },
]
